module.exports = __webpack_public_path__ + "img/comment-participer.273ad6c1.png";